import { Tabs } from 'antd'
import React from 'react'
import { t } from 'i18next'
import ActiveIntervenersTab from './ActiveIntervenersTab'
import DeletedIntervenersTab from './DeletedIntervenersTab'

export default function IntervenersTab ({ activeInterveners, deletedInterveners, deleteModal }) {
  return (
    <Tabs
      defaultActiveKey='active'
      items={[
        {
          label: t('Admin.IntervenersPage.tab.active'),
          key: 'active',
          children: <ActiveIntervenersTab interveners={activeInterveners} deleteModal={deleteModal} />
        },
        {
          label: t('Admin.IntervenersPage.tab.deleted'),
          key: 'deleted',
          children: <DeletedIntervenersTab interveners={deletedInterveners} />
        }
      ]}
    />
  )
}
